import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgChartVerticalIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.333 56V5.333H8V56h50.666v2.667H8A2.667 2.667 0 0 1 5.333 56M40 16v34.667h-2.667V16zm-21.334 5.333v29.334H16V21.333zm8 29.334v-24h2.667v24zm24-18.667v18.667H48V32z"
    />
  </svg>
)
export default SvgChartVerticalIcon
